import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import Select from "react-select";
import config from "../../config";

export const PetDrawer = ({ isOpen, onClose, onSave, petToEdit, guestPetData,quickAddMode = false ,  existingPets = [] }) => {

  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;
  const client_id = decoded?.data?.customer_data?.id || "";

  const [petTypes, setPetTypes] = useState([]);
  const [petBreeds, setPetBreeds] = useState([]);
  const [petSizes, setPetSizes] = useState([]);

  const [pendingSizePrefill, setPendingSizePrefill] = useState(null);
  const [duplicateNameError, setDuplicateNameError] = useState(false);
  const [localPets, setLocalPets] = useState([]);
  const [isFetchingPets, setIsFetchingPets] = useState(false);

  //const showBreedField = !quickAddMode || !!guestPetData?.petBreed_id;
  const showBreedField = !quickAddMode || !guestPetData?.petBreed_id;
  const showSizeField = !quickAddMode || !!guestPetData?.petSize_id;

  const [petData, setPetData] = useState({
    name: "",
    pet_type: "",
    gender: "Male",
    breed: "",
    size: "",
    birthday: "",
    weight_kg: "",
    age: "",
    tags: [],
    hair_type: "",
    hair_length: "",
    behavior_notes: "",
    profile_photo: "",
  });

  const [years, setYears] = useState("");
  const [months, setMonths] = useState("");
  const [days, setDays] = useState("");
  const [ageMode, setAgeMode] = useState("dob");

  const [profileImageFile, setProfileImageFile] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState("");

  // const tagOptions = ["Allergic", "Aggressive", "Friendly", "Senior", "Puppy"];
  // const hairTypes = [
  //   "Smooth",
  //   "Wire",
  //   "Double",
  //   "Hairless",
  //   "Curly",
  //   "Wavy",
  //   "Drop Coat",
  // ];
  // const hairLengths = ["Short Hair", "Medium Hair", "Long Hair"];
const [showCloseConfirm, setShowCloseConfirm] = useState(false);
const [hasBreeds, setHasBreeds] = useState(false);
const [hasSizes, setHasSizes] = useState(false);

  useEffect(() => {
    fetchPetTypes();
    fetchBreeds();
    fetchSizes();
  }, []);

  useEffect(() => {
    if (petData.pet_type) {
      fetchSizes(petData.pet_type);
    } else {
      setPetSizes([]);
    }
  }, [petData.pet_type]);

  useEffect(() => {
  if (!isOpen) {
    setProfileImageFile(null);
    setProfileImageUrl("");
  }
}, [isOpen]);

// Prevent background scrolling when drawer is open

  useEffect(() => {
    if (!isOpen) return undefined;

    const originalOverflow = document.body.style.overflow;
    const originalTouchAction = document.body.style.touchAction;

    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.touchAction = originalTouchAction;
    };
  }, [isOpen]);

  const fetchPetTypes = async () => {
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/customer/customerpettype`
      );
      setPetTypes(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch {
      setPetTypes([]);
    }
  };

  const fetchBreeds = async () => {
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/customer/customerbreed`
      );
      if (res.data?.status) setPetBreeds(res.data.data);
    } catch {
      toast.error("Failed to fetch breeds");
    }
  };

  const fetchSizes = async (petTypeId) => {
    if (!petTypeId) {
      setPetSizes([]);
      return;
    }
    try {
      const res = await axios.get(
        `${config.API_BASE_URL}/customer/customerpetsize`,
        { params: { pet_type: petTypeId } }
      );
      if (res.data?.status) {
        //setPetSizes(res.data.data || []);
        const sizes = res.data.data || [];
      setPetSizes(sizes);
      setHasSizes(sizes.length > 0);
      }else {
      setPetSizes([]);
      setHasSizes(false); 
    }
    } catch {
      toast.error("Failed to fetch pet sizes");
      setPetSizes([]);
       setHasSizes(false);
    }
  };
  
   useEffect(() => {
    const fetchExistingPets = async () => {
      if (isOpen && existingPets.length === 0 && client_id && !petToEdit) {
        setIsFetchingPets(true);
        try {
          const token = localStorage.getItem("token");
          const res = await axios.post(
            `${config.API_BASE_URL}/customer/getallpet`,
            { client_id },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const petList = res.data?.pets || [];
          setLocalPets(petList);
        } catch (error) {
          console.error("Failed to fetch pets in drawer:", error);
        } finally {
          setIsFetchingPets(false);
        }
      }
    };
    
    fetchExistingPets();
  }, [isOpen, client_id, existingPets.length, petToEdit]);



  const normalizeCase = (value, defaultValue = "") => {
    if (!value || typeof value !== 'string') return defaultValue;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  };

  const normalizeTitleCase = (value) => {
    if (!value || typeof value !== 'string') return "";
    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const normalizeFieldValue = (field, value, defaultValue = "") => {
    if (!value || typeof value !== 'string') return defaultValue;
    const valueLower = value.toLowerCase().trim();
    switch (field) {
      case 'gender':
        return valueLower === 'male' ? 'Male' : valueLower === 'female' ? 'Female' : normalizeCase(value, defaultValue);
      case 'hair_type':
        const hairMap = {
          'smooth': 'Smooth', 'wire': 'Wire', 'double': 'Double', 'hairless': 'Hairless',
          'curly': 'Curly', 'wavy': 'Wavy', 'drop coat': 'Drop Coat', 'dropcoat': 'Drop Coat'
        };
        return hairMap[valueLower] || normalizeTitleCase(value);
      case 'hair_length':
        if (valueLower.includes('short')) return 'Short Hair';
        if (valueLower.includes('medium')) return 'Medium Hair';
        if (valueLower.includes('long')) return 'Long Hair';
        return normalizeTitleCase(value);
      default:
        return value;
    }
  };

  const extractSizeValue = (pet) => {
    if (!pet) return "";
    if (pet.size_label) return pet.size_label;
    if (typeof pet.size === 'object' && pet.size?.size_label) return pet.size.size_label;
    if (typeof pet.size === 'object' && pet.size?._id) return pet.size._id;
    if (typeof pet.size === 'string') return pet.size;
    return "";
  };

  useEffect(() => {
    if (isOpen && petToEdit) {
      const ageStr = petToEdit.age || "";
      const y = ageStr.match(/(\d+)y/)?.[1] || "";
      const m = ageStr.match(/(\d+)m/)?.[1] || "";
      const d = ageStr.match(/(\d+)d/)?.[1] || "";

      setYears(y);
      setMonths(m);
      setDays(d);

      setProfileImageFile(null); // Clear any pending new upload
      setProfileImageUrl("");

      const sizeValue = extractSizeValue(petToEdit);

      setPetData({
        name: petToEdit.name || "",
        pet_type: petToEdit.pet_type?._id || petToEdit.pet_type || "",
        gender: normalizeFieldValue('gender', petToEdit.gender, "Male"),
        breed: petToEdit.breed?._id || petToEdit.breed || "",
        size: sizeValue,
        birthday: petToEdit.birthday?.slice(0, 10) || "", 
        weight_kg: petToEdit.weight_kg || "",
        age: petToEdit.age || "",
        tags: petToEdit.tags || [],
        hair_type: normalizeFieldValue('hair_type', petToEdit.hair_type),
        hair_length: normalizeFieldValue('hair_length', petToEdit.hair_length),
        behavior_notes: petToEdit.behavior_notes || "",
        profile_photo: petToEdit.profile_photo || "",
        
      });
    }

    if (isOpen && !petToEdit) {
      setPetData({
        name: "", pet_type: "", gender: "Male", breed: "", size: "", birth_date: "",
        weight_kg: "", age: "", tags: [], hair_type: "", hair_length: "", behavior_notes: "", profile_photo: ""
      });
      setYears(""); setMonths(""); setDays("");
      setProfileImageFile(null); 
      setProfileImageUrl("");
    }
  }, [isOpen, petToEdit]);

  const filteredBreeds = petBreeds.filter(b => b.pet_type_id === petData.pet_type);

  useEffect(() => {
  setHasBreeds(filteredBreeds.length > 0);
}, [filteredBreeds]);


  const generateAgeString = (y, m, d) => {
  let str = "";
  if (y) str += `${y}y `;
  if (m) str += `${m}m `;
  if (d) str += `${d}d`;
  return str.trim();
};

  useEffect(() => {
    setPetData(prev => ({ ...prev, age: generateAgeString(years, months, days) }));
  }, [years, months, days]);

  const handleDob = (e) => {
    const date = e.target.value;
    setPetData(prev => ({ ...prev, birthday: date }));
    if (!date) return;

    const birth = new Date(date);
    const today = new Date();
    let y = today.getFullYear() - birth.getFullYear();
    let m = today.getMonth() - birth.getMonth();
    let d = today.getDate() - birth.getDate();

    if (d < 0) { m--; d += new Date(today.getFullYear(), today.getMonth(), 0).getDate(); }
    if (m < 0) { y--; m += 12; }

    setYears(String(y));
    setMonths(String(m));
    setDays(String(d));
  };

  const getAgeFromDOB = (date) => {
  if (!date) return { y: "0", m: "0", d: "0" };

  const birth = new Date(date);
  const today = new Date();

  let y = today.getFullYear() - birth.getFullYear();
  let m = today.getMonth() - birth.getMonth();
  let d = today.getDate() - birth.getDate();

  if (d < 0) {
    m--;
    d += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
  }
  if (m < 0) {
    y--;
    m += 12;
  }

  return { y: String(y), m: String(m), d: String(d) };
};

const petsForValidation = existingPets.length > 0 ? existingPets : localPets;

   const checkDuplicatePetName = () => {
    if (petToEdit) return true;    
    const normalizedName = petData.name?.trim().toLowerCase();
    if (!normalizedName) return true;
    
    const isDuplicate = petsForValidation.some(pet => {
      if (!pet?.name) return false;
      if (petToEdit && pet._id === petToEdit._id) return false;
      return pet.name.trim().toLowerCase() === normalizedName;
    });
    
    if (isDuplicate) {
      toast.error(`A pet named "${petData.name}" already exists. Please use a different name.`);
      return false;
    }
    
    return true;
  };

  const validateForm = () => {
    if (!petData.name.trim()) {
      toast.error("Pet name is required");
      return false;
    }
    
    if (!petData.pet_type) {
      toast.error("Pet type is required");
      return false;
    }
    //if (!petData.breed) {
      //toast.error("Breed is required");
     // return false;
   // }
    //if (!petData.size) {
    //  toast.error("Size is required");
    //  return false;
   // }
    
   if (hasBreeds && !petData.breed) {
    toast.error("Please select a breed for your pet");
    return false;
  }
 
  // Only validate size if sizes are available
  if (hasSizes && !petData.size) {
    toast.error("Please select a size for your pet");
    return false;
  }
    return true;
  };

  useEffect(() => {
  if (!isOpen) return;

  if (quickAddMode && guestPetData && !petToEdit) {
    const updates = {
      name: "",
      pet_type: guestPetData.pet_type_id || "",
      size: guestPetData.petSize_id || "",
      breed: guestPetData.petBreed_id || "",
      gender: "Male",
      weight_kg: "",
    };

    setPetData(prev => ({ ...prev, ...updates }));
  }
}, [isOpen, quickAddMode, guestPetData, petToEdit]);

useEffect(() => {
  if (petData.pet_type) {
    fetchSizes(petData.pet_type);
    fetchBreeds(petData.pet_type);
  }
}, [petData.pet_type]);

  // use effect to check for duplicate pet name
   useEffect(() => {
    if (!petToEdit && petData.name?.trim()) {
      const normalizedName = petData.name.trim().toLowerCase();
      const isDuplicate = petsForValidation.some(pet => 
        pet?.name && 
        pet.name.trim().toLowerCase() === normalizedName &&
        (!petToEdit || pet._id !== petToEdit._id)
      );
      setDuplicateNameError(isDuplicate);
    } else {
      setDuplicateNameError(false);
    }
  }, [petData.name, petsForValidation, petToEdit]);

  const handleMediaUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("module", "Pet");
      formData.append("docType", "profile_photo");
      formData.append("customerId", client_id);

      const res = await axios.post(
        `${config.API_BASE_URL}/upload/fileuploadcustomer`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return res.data.data.s3Url;
    } catch (err) {
      toast.error("Image upload failed");
      return null;
    }
  };

  const handleSizePrefill = (petSize, petTypeId) => {
  // This will be called after pet type is set
  setPendingSizePrefill(petSize);
};

  const handleSave = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

  if (petData.weight_kg && Number(petData.weight_kg) <= 0) {
    toast.error("Weight must be greater than 0");
    return;
  }

   // Function to generate unique name (ONLY for new pets, not edits)
  const generateUniquePetName = (desiredName) => {
    const existingNames = petsForValidation.map(pet => pet.name);
    const desiredNameLower = desiredName.toLowerCase();
    
    // Check if exact name exists (case insensitive)
      const exactMatchExists = existingNames.some(name => 
        name.toLowerCase() === desiredNameLower
      );
      
      // If exact name doesn't exist, return as is
      if (!exactMatchExists) {
        return desiredName;
      }
      
      // Find the highest suffix number
      let maxSuffix = 0;
      
      // Check for patterns like "kittu 1", "kittu 2", etc.
      existingNames.forEach(name => {
        if (name.toLowerCase().startsWith(desiredNameLower + "-")) {
          const suffix = name.substring(desiredName.length + 1);
          if (/^\d+$/.test(suffix)) {
            const num = parseInt(suffix, 10);
            if (num > maxSuffix) maxSuffix = num;
          }
        }       
      });
      
      // Start from 1
      const nextNumber = maxSuffix + 1;
      return `${desiredName}-${nextNumber}`;
    };
    
    // ONLY generate unique name for NEW pets (not editing)
    const finalPetName = petToEdit ? petData.name : generateUniquePetName(petData.name);
    
    // Check if name was changed (for showing appropriate message)
    const nameWasChanged = !petToEdit && finalPetName !== petData.name;
    
    try {
      let profilePhotoUrl = petData.profile_photo;
      if (profileImageFile) {
        const uploadedUrl = await handleMediaUpload(profileImageFile);
        if (!uploadedUrl) {
          return;
        }
        profilePhotoUrl = uploadedUrl;
      }

      // Fix: Handle birth_date properly - send null if empty
      //const birthDateValue = petData.birth_date && petData.birth_date.trim() !== "" 
       // ? petData.birth_date 
       // : null;

      // Fix: Handle size - ensure we send the ID, not the label
      let sizeValue = petData.size;
      
      // If size is a label string, find the matching ID from petSizes
      if (petData.size && !petData.size.match(/^[0-9a-fA-F]{24}$/)) {
        const foundSize = petSizes.find(s => 
          s.size_label === petData.size || s._id === petData.size
        );
        if (foundSize) {
          sizeValue = foundSize._id;
        }
      }

      const payload = {
        client_id: client_id,
        //name: petData.name,
        name: finalPetName,
        pet_type: petData.pet_type,
        gender: petData.gender,
        breed: petData.breed,
        size: sizeValue,
        birthday: petData.birthday || null, // <-- Now matches backend
        weight_kg: petData.weight_kg || null,
        age: petData.age,
        tags: petData.tags,
        hair_type: petData.hair_type || null,
        hair_length: petData.hair_length || null,
        behavior_notes: petData.behavior_notes || null,
        profile_photo: profilePhotoUrl || null,
      };

      // Remove any empty strings that should be null
      Object.keys(payload).forEach(key => {
        if (payload[key] === "") {
          payload[key] = null;
        }
      });

      let res;
      if (petToEdit) {
        res = await axios.put(
          `${config.API_BASE_URL}/customer/updatepet/${petToEdit._id}`,
          payload
        );
      } else {
        res = await axios.post(
          `${config.API_BASE_URL}/customer/customeraddpet`,
          payload
        );

        if (nameWasChanged) {
        toast.success(`Pet saved as "${finalPetName}" ( "${petData.name}" already exists )`);
      } else {
        toast.success("Pet added successfully!");
      }
      }

      const isError = res.data?.success === false || res.data?.status === false || res.data?.error === "error";
      if (isError) {
        const errorMsg = Array.isArray(res.data?.message) ? res.data.message.flat().join(", ") : res.data?.message || "Failed to save pet";
        toast.error(errorMsg);
        return;
      }

      toast.success(petToEdit ? "Pet updated successfully!" : "Pet added successfully!");
      onSave?.();
      onClose();
    } catch (err) {
      console.error("Save error:", err.response?.data || err.message);
      toast.error(err.response?.data?.message || err.response?.data?.error || "Failed to save pet");
    }
  };

  if (!isOpen) return null;


  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-[1200]" />

      {/* Drawer */}
      <div
        className={`fixed inset-y-0 right-0 h-[100dvh] w-full max-w-lg bg-white shadow-2xl flex flex-col transform transition-transform duration-300 z-[1210] overscroll-contain ${isOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Header - Matches CartDrawer */}
        <div className="flex justify-between items-center px-4 sm:px-5 py-4 border-b bg-orange-50 shrink-0">
          <h2 className="text-lg font-semibold text-gray-800">
            {petToEdit ? "Edit Pet" : quickAddMode  ? "Add Pet Details" : "Add New Pet"}
          </h2>
          <button
            onClick={() => setShowCloseConfirm(true)}
            className="text-gray-600 hover:text-gray-800"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto overscroll-contain p-4 sm:p-5 space-y-6">
          <form id="petForm" onSubmit={handleSave} className="space-y-6">
            {/* Profile Photo + Name */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5 p-4 bg-gray-50 rounded-xl">
              <div className="relative ">
                <div className="w-24 h-24 rounded-full border-4 border-white shadow-md overflow-hidden bg-gray-100 flex items-center justify-center">
                 {/* ✅ Show Image ONLY if exists */}
                  {(profileImageFile || petData.profile_photo) ? (
                    <img
                      src={
                        profileImageFile
                          ? URL.createObjectURL(profileImageFile)
                          : petData.profile_photo
                      }
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    /* ✅ Clean Placeholder with Camera Icon */
                    <div className="flex flex-col items-center justify-center text-gray-400">
                      <svg
                        className="w-6 h-6 mb-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 7h4l2-2h6l2 2h4v12H3V7z"
                        />
                        <circle cx="12" cy="13" r="3" />
                      </svg>
                      <span className="text-xs">Add</span>
                    </div>
                  )}
                </div>

                <label className="absolute bottom-0 right-0 bg-orange-500 text-white p-2 rounded-full cursor-pointer hover:bg-orange-600 transition">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) =>
                      e.target.files[0] &&
                      setProfileImageFile(e.target.files[0])
                    }
                  />
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                    />
                  </svg>
                </label>
              </div>
              <div className="flex-1 w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Pet Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={petData.name}
                  onChange={(e) =>
                    setPetData({ ...petData, name: e.target.value })
                  }
                 className= "w-full px-4 py-2.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 "
                  placeholder="Enter pet name"
                />
              </div>
            </div>

            {quickAddMode ? (
              // QUICK ADD MODE: Horizontal layout (all three in one row)
              <div className="grid grid-cols-3 sm:grid-cols-1 gap-3">
                {/* Pet Type / Species */}
                <div>
                  <label className="block text-sm px-3 font-medium text-gray-700 mb-2">
                    Species <span className="text-red-500">*</span>
                  </label>
                  <div className="py-2 px-4 rounded-lg border bg-orange-100 text-orange-700 font-medium">
                    {petTypes.find(t => t._id === petData.pet_type)?.name || "Selected Pet Type"}
                  </div>
                </div>

                {/* Breed Field */}
                 {guestPetData?.petBreed_id ? (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Breed {hasBreeds && <span className="text-red-500">*</span>}
        </label>
        <div className="px-4 py-2.5 border rounded-lg bg-gray-100 truncate">
          {petBreeds.find(b => b._id === petData.breed)?.breed_name || "Selected Breed"}
        </div>
      </div>
    ) : (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Breed {hasBreeds && <span className="text-red-500">*</span>}
        </label>
        <Select
          options={filteredBreeds}
          value={filteredBreeds.find(b => b._id === petData.breed) || null}
          onChange={(selectedOption) => {
            setPetData({ ...petData, breed: selectedOption?._id || "" });
          }}
          getOptionLabel={(option) => option.breed_name}
          getOptionValue={(option) => option._id}
          placeholder={filteredBreeds.length === 0 ? "No breed available" : "Search or select breed..."}
          isClearable
          isSearchable
          isDisabled={filteredBreeds.length === 0}
          noOptionsMessage={() => "No breed available"}
          className="react-select-container"
          classNamePrefix="react-select"
          styles={{
            control: (base) => ({
              ...base,
              minHeight: '42px',
              borderColor: '#e2e8f0',
              borderRadius: '0.5rem',
              boxShadow: 'none',
              '&:hover': {
                borderColor: '#fd5901'
              }
            }),
            placeholder: (base) => ({
              ...base,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }),
            singleValue: (base) => ({
              ...base,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            })
          }}
        />
      </div>
    )}

                {/* Size Field */}
                {showSizeField && (
                  <div>
                    <label className="block text-sm px-3 font-medium text-gray-700 mb-2">
                      Size {hasSizes && <span className="text-red-500">*</span>}
                    </label>
                    <div className="py-2 px-4 border rounded-lg  bg-gray-100 ">
                      {petSizes.find(s => s._id === petData.size)?.size_label || "Selected Size"}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              // NORMAL/EDIT MODE: Original layout (Species full width, Breed & Size in row)
              <>
              {/* Pet Type */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Species <span className="text-red-500">*</span>
              </label>

              <div className="sm:hidden">
                <select
                  value={petData.pet_type}
                  onChange={(e) =>
                    setPetData({ ...petData, pet_type: e.target.value, breed: "" , size: ""})
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
                >
                  <option value="">Select Species</option>
                  {petTypes.map((t) => (
                    <option key={t._id} value={t._id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-3">
                 
                {petTypes.map((t) => (
                // petTypes.map((t) => (
                  <button
                    key={t._id}
                    type="button"
                    onClick={() =>
                     // !quickAddMode &&
                      setPetData({ ...petData, pet_type: t._id, breed: "", size: "" })
                    }
                    className={`py-3 px-4 rounded-lg border font-medium transition ${
                      petData.pet_type === t._id
                        ? "bg-orange-500 text-white border-orange-500"
                        : "bg-white border-gray-300 hover:border-orange-400"
                    }`}
                  >
                    {t.name}
                  </button>
                 ))}
              </div>
            </div>

            {/* Breed & Size */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {showBreedField && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Breed {hasBreeds && <span className="text-red-500">*</span>}
                  {!hasBreeds && petData.pet_type && (
                    <span className="text-xs text-gray-500 ml-2"></span>
                  )}
                </label>
                 <Select
                    options={filteredBreeds}
                    value={filteredBreeds.find(b => b._id === petData.breed) || null}
                    onChange={(selectedOption) => {
                      setPetData({ ...petData, breed: selectedOption?._id || "" });
                    }}
                    getOptionLabel={(option) => option.breed_name}
                    getOptionValue={(option) => option._id}
                    placeholder={filteredBreeds.length === 0 ? "No breed available" : "Search or select breed..."}
                    isClearable
                    isSearchable
                    isDisabled={filteredBreeds.length === 0}
                     noOptionsMessage={() => "No breed available"}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '42px',
                        borderColor: '#e2e8f0',
                        borderRadius: '0.5rem',
                        boxShadow: 'none',
                        '&:hover': {
                          borderColor: '#fd5901'
                        }
                      }),
                      placeholder: (base) => ({
                        ...base,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }),
                      singleValue: (base) => ({
                        ...base,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      })
                    }}
                  />
                    </div>
                  )}
                
                {/* <select 
                  value={petData.breed}
                  onChange={(e) =>
                    setPetData({ ...petData, breed: e.target.value })
                  }
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                >
                  {filteredBreeds.length === 0 ? (
                  <option value="">No breed available</option>
                  ) : (
                  <>
                  <option value="">Select Breed</option>
                  {filteredBreeds.map((b) => (
                    <option key={b._id} value={b._id}>
                      {b.breed_name}
                    </option>
                  ))}
                   </>
                  )}
                </select>
              </div>
             )} */}

            {showSizeField && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Size {hasSizes && <span className="text-red-500">*</span>}
                  {!hasSizes && petData.pet_type && (
                    <span className="text-xs text-gray-500 ml-2"></span>
                  )}
                </label>
                <div className="sm:hidden">
                  <select
                    value={petData.size}
                    onChange={(e) =>
                      setPetData((prev) => ({ ...prev, size: e.target.value }))
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
                  >
                    <option value="">
                      {petSizes.length ? "Select Size" : "No size available"}
                    </option>
                    {petSizes.map((s) => (
                      <option key={s._id} value={s._id}>
                        {s.size_label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="hidden sm:flex flex-wrap gap-2">
              
                  {petSizes.map((s) => (
                 // petSizes.map((s) => (
                    <button
                      key={s._id}
                      type="button"
                      onClick={() =>
                        setPetData((prev) => ({ ...prev, size: s._id }))
                      }
                      className={`px-4 py-2 rounded-full text-sm font-medium border transition ${
                        petData.size === s._id
                          ? "bg-orange-500 text-white border-orange-500"
                          : "bg-white border-gray-300 hover:border-orange-400"
                      }`}
                    >
                      {s.size_label}
                    </button>
                  ))}
                  
                  {petSizes.length === 0 && petData.pet_type && (
                    <p className="text-sm text-gray-500 italic">
                    </p>
                  )}
                </div>
              </div>
              )}
            </div>
           </>
          )}
            {/* Gender & Weight */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Gender
                </label>
                <div className="grid grid-cols-2 gap-3">
                  {["Male", "Female"].map((g) => (
                    <button
                      key={g}
                      type="button"
                      onClick={() => setPetData({ ...petData, gender: g })}
                      className={`py-2.5 rounded-lg border font-medium transition ${
                        petData.gender === g
                          ? "bg-orange-500 text-white border-orange-500"
                          : "bg-white border-gray-300"
                      }`}
                    >
                      {g}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {" "}
                  Weight (kg){" "}
                </label>
                <input
                  type="Text"
                  value={petData.weight_kg || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only positive numbers up to 999.99
                    if (/^(?:\d{0,3})(?:\.\d{0,2})?$/.test(value)) {
                      setPetData((prev) => ({
                        ...prev,
                        weight_kg: value,
                      }));
                    }
                  }}
                  placeholder="e.g. 5.2"
                  className="w-full sm:w-1/2 px-4 sm:px-6 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                />
              </div>
            </div>

            {/* Age / DOB */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Age / Date of Birth
              </label>
              <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                <div className="flex bg-gray-100 rounded-lg p-1">
                  <button
                    type="button"
                    onClick={() => setAgeMode("dob")}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition ${ageMode === "dob" ? "bg-white shadow text-orange-600" : "text-gray-600"}`}
                  >
                    Select DOB
                  </button>
                  <button
                    type="button"
                    onClick={() => setAgeMode("manual")}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition ${ageMode === "manual" ? "bg-white shadow text-orange-600" : "text-gray-600"}`}
                  >
                    Enter Age
                  </button>
                </div>

                {ageMode === "dob" && (
                  <input
                    type="date"
                    value={petData.birthday}
                    onChange={handleDob}
                    max={new Date().toISOString().split("T")[0]}
                    className="flex-1 px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                )}
                {ageMode === "manual" && (
                  <div className="flex gap-3 flex-1">
                    <select
                      value={years}
                      onChange={(e) => {
                        const newYears = e.target.value;

                        if (newYears !== years && petData.birthday) {
                          setPetData((prev) => ({ ...prev, birthday: "" }));
                        }
                        setYears(newYears);
                      }}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-orange-500"
                    >
                      <option value="" disabled>
                        Years
                      </option>
                      {Array.from({ length: 26 }, (_, i) => (
                        <option key={i} value={i}>
                          {i}
                        </option>
                      ))}
                    </select>

                    {/* Months Dropdown */}
                    <select
                      value={months}
                      onChange={(e) => {
                        const newMonths = e.target.value;

                        if (newMonths !== months && petData.birthday) {
                          setPetData((prev) => ({ ...prev, birthday: "" }));
                        }

                        setMonths(newMonths);
                      }}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-orange-500"
                    >
                      <option value="" disabled>
                        Months
                      </option>

                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i} value={i}>
                          {i}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div> 

        {/* Sticky Footer */}
        <div className="p-4 sm:p-5 border-t bg-gray-50 shrink-0">
          <button
            type="submit"
            form="petForm"
            className={`w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-3 rounded-lg transition-all shadow-md hover:shadow-lg ${
             showSizeField && !petData.size ? "opacity-50 cursor-not-allowed" : "" 
            }`}
            //disabled={!petData.size}
          >
            {petToEdit ? "Update Pet" : "Save Pet"}
          </button>
        </div>
      </div>
      {showCloseConfirm && (
        <div className="fixed inset-0 z-[1220] flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 w-[90%] max-w-sm text-center shadow-xl">
            <div className="text-3xl mb-2">🐾</div>

            <h3 className="text-lg font-semibold text-gray-800">
              Discard changes?
            </h3>

            <p className="text-sm text-gray-500 mt-2">
              Your changes will not be saved.
            </p>

            <div className="flex gap-3 mt-5">
              <button
                onClick={() => setShowCloseConfirm(false)}
                className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  setShowCloseConfirm(false);
                  onClose();
                }}
                className="flex-1 py-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600"
              >
                Yes, Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};